import React, { useEffect, useState } from 'react';

const FloatingActions = () => {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false); // for dropdown

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="fixed right-4 bottom-6 z-[60] flex flex-col gap-3" style={{maxWidth:'50px'}}>
      {/* WhatsApp */}
      {open && (
        <div className="bg-white shadow-xl rounded-lg p-3 mb-2 w-56">
          <a
            href="https://wa.me/+14242080382"
            target="_blank"
            className="block text-green-600 font-semibold py-1 hover:underline"
          >
            <span className="text-xl">🌍</span>
          </a>

          <a
            href="https://wa.me/+918899251695"
            target="_blank"
            className="block text-green-600 font-semibold py-1 hover:underline"
          >
            <span><img src="https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f1ee-1f1f3.svg" width="24" /></span>

          </a>
        </div>
      )}

      {/* WhatsApp — Single Button */}
      <button
        onClick={() => setOpen(!open)}
        className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center shadow-xl hover:scale-105 transition"
        aria-label="Chat on WhatsApp"
      >
        <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.62-6.003C.122 5.281 5.403 0 12.057 0c3.17 0 6.167 1.237 8.413 3.484A11.82 11.82 0 0124 11.944c-.002 6.654-5.283 11.935-11.938 11.935a11.95 11.95 0 01-6.003-1.62L.057 24zm6.597-3.807c1.741 1.044 3.276 1.676 5.392 1.676 5.448 0 9.886-4.434 9.888-9.877.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.885 0 2.225.651 3.891 1.746 5.634l-.999 3.648 3.743-.974zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.03-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.149-.174.198-.297.297-.495.099-.198.05-.372-.025-.521-.074-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.718 2.006-1.413.248-.695.248-1.29.173-1.414z" />
        </svg>
      </button>

      {/* Back to top */}
      <button
        onClick={scrollTop}
        className={`w-12 h-12 rounded-full bg-[var(--color-primary)] text-[var(--color-text-inverse)] flex items-center justify-center shadow-xl hover:scale-105 transition ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        aria-label="Back to top"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
        </svg>
      </button>
    </div>
  );
};

export default FloatingActions;





